import { Observable } from 'rxjs';
import { UseCase }
from '../../base/use-case';
import { DocumentsSystemModel }
from '../../models/configuration/documents-system.model';
import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class GetDocumentsSystemUseCase implements UseCase<void,DocumentsSystemModel> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(): Observable<DocumentsSystemModel> {
        return this.repository.getDocumentsSystem();
    }
}